module.exports = __webpack_public_path__ + "01_mustache_black.ff18b15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/01_mustache_black.png
// module id = YwN5
// module chunks = 0